import React, { useEffect, useRef } from "react";
import styles from "./BottomActions.module.css";
import { logSubtotalChange } from "../../../../utils/optimisticLogger";

interface Props {
  subtotal: string;
  hasPromotionalDiscounts?: boolean;
  hasOptimisticItems?: boolean;
  handleNavigate: (path: string) => void;
  toggleMiniCart: () => void;
}

const BottomActions: React.FC<Props> = ({
  subtotal,
  hasPromotionalDiscounts = false,
  hasOptimisticItems = false,
  handleNavigate,
  toggleMiniCart,
}) => {
  const previousSubtotalRef = useRef<string>(subtotal);

  // Log subtotal changes to track overwrites
  useEffect(() => {
    if (previousSubtotalRef.current !== subtotal) {
      const previousValue =
        parseFloat(previousSubtotalRef.current.replace(/[^\d.-]/g, "")) || 0;
      const currentValue = parseFloat(subtotal.replace(/[^\d.-]/g, "")) || 0;

      logSubtotalChange(
        "BottomActions.subtotalDisplay",
        previousValue,
        currentValue,
        { hasOptimisticItems },
        {
          trigger: "subtotal_display_change",
          hasPromotionalDiscounts,
          previousString: previousSubtotalRef.current,
          currentString: subtotal,
        }
      );

      previousSubtotalRef.current = subtotal;
    }
  }, [subtotal, hasOptimisticItems, hasPromotionalDiscounts]);

  const handleGoToCart = () => {
    toggleMiniCart();
    handleNavigate("/cart");
  };

  return (
    <div className={styles.container}>
      <div className={styles.subtotalContainer}>
        <span className={styles.subtotalLabel}>
          {hasPromotionalDiscounts ? "Subtotal (c/dctos):" : "Subtotal:"}
        </span>
        <span
          className={`${styles.subtotalValue} ${
            hasOptimisticItems ? styles.optimisticSubtotal : ""
          }`}
        >
          {subtotal}
        </span>
      </div>

      <div className={styles.buttonsContainer}>
        <button
          className="buttonMain"
          onClick={handleGoToCart}
          aria-label="Ver mi carrito"
        >
          Ver mi carrito
        </button>
      </div>
    </div>
  );
};

export default BottomActions;
